(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('bagBannerInput', {
            templateUrl: 'app/admin/bag/banner-input/banner-input.html',
            controller: bagBannerInputController,
            bindings: {
                label: '@',
                banners: '=',
                required: '<?',
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function bagBannerInputController($uibModal,$window, $scope, $timeout, systemConstants) {
        var vm = this;
        vm.$onInit = init;

        // exposed functions
        vm.openAddBannersModal = openAddBannersModal;
        vm.removeBanner = removeBanner;

        function init() {
            vm.currentIndex = vm.banners && vm.banners.length > 0 ? 0 : undefined;
            vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
            $scope.$watch('vm.banners.length', function () {
                vm.currentIndex = vm.banners && vm.banners.length > 0 ? 0 : undefined;
            });
        }

        function openAddBannersModal() {
            vm.loadingBanners = true;
            vm.filtersConversationModal = $uibModal
                .open({
                    templateUrl:
                        "app/admin/showcases/banner-modal/banners_modal.html",
                    controller: "BannersModalController",
                    windowClass: "modal-center",
                    windowTopClass: "center-modal",
                    controllerAs: "vm",
                    size: "lg",
                    keyboard: false,
                    resolve: {
                        banners: function () {
                            return vm.banners;
                        },
                        userAccount: function () {
                            return undefined;
                        },
                    },
                })
                .result.then(function (response) {
                    if (response) {
                        vm.banners = response.banners;
                    }
                    vm.loadingBanners = false;
                }, function () {
                    vm.loadingBanners = false;
                });
        }

        function removeBanner(index) {
            vm.loadingBanners = true;

            $timeout(function () {
                if (vm.banners && vm.banners.length > 1) {
                    vm.banners.splice(index, 1);
                    vm.currentIndex = index > 0 ? index - 1 : 0;
                }
                vm.loadingBanners = false;
            }, 200);
        }
    }
})();
